export const EDIT_SUPPORT_MATERIAL_TYPE = "EDIT_SUPPORT_MATERIAL_TYPE"
export const EDIT_SUPPORT_MATERIAL_TYPE_SUCCESS =
  "EDIT_SUPPORT_MATERIAL_TYPE_SUCCESS"
export const EDIT_SUPPORT_MATERIAL_TYPE_CLEAN =
  "EDIT_SUPPORT_MATERIAL_TYPE_CLEAN"
export const EDIT_SUPPORT_MATERIAL_TYPE_ERROR =
  "EDIT_SUPPORT_MATERIAL_TYPE_ERROR"
